export const CHART = {
  width: 320,
  height: 190,
  left: 24,
  right: 296,
  top: 40,
  bottom: 150,
};

const START = { x: CHART.left, y: CHART.bottom - 18 };
const GOAL = { x: CHART.right, y: CHART.top };

/* A slow start that accelerates — the "curve up" most plans promise. */
const CONTROL_A = { x: CHART.left + 120, y: CHART.bottom - 6 };
const CONTROL_B = { x: CHART.right - 70, y: CHART.top + 10 };

export const curvePath = (): string =>
  `M ${START.x} ${START.y} C ${CONTROL_A.x} ${CONTROL_A.y}, ${CONTROL_B.x} ${CONTROL_B.y}, ${GOAL.x} ${GOAL.y}`;

export const areaPath = (): string =>
  `${curvePath()} L ${GOAL.x} ${CHART.bottom} L ${START.x} ${CHART.bottom} Z`;

export const chartPoints = { start: START, goal: GOAL };

/** Evenly spaced x positions for `count` tick labels along the axis. */
export const tickPositions = (count: number): number[] => {
  if (count < 2) return [CHART.left];
  const span = CHART.right - CHART.left;
  return Array.from({ length: count }, (_, i) => CHART.left + (span * i) / (count - 1));
};
